import { render } from "./App.vue?vue&type=template&id=54313cac"
const script = {}

import "./App.vue?vue&type=style&index=0&id=54313cac&lang=css"
script.render = render

export default script